import common from './common';
import buyer from './buyer';
import supplier from './supplier';
import supplierAdmin from './supplier_admin';
import admin from './admin';

export default {
  admin: [
    ...admin,
  ],
  mro_manage_buyer: [
    ...common,
    ...buyer,
  ],
  mro_buyer: [
    ...common,
    ...buyer,
  ],
  mro_manage_supplier: [
    ...common,
    ...supplier,
    ...supplierAdmin,
  ],
  mro_supplier: [
    ...common,
    ...supplier,
  ],
};



// WEBPACK FOOTER //
// ./src/router/routes/index.js